import {
  EditableCountryCell,
  EditableCountryCellViewMode,
  EditableCountryCellEditMode,
} from '@src/shared/components/editable-country-cell';
import { getCachedLocales } from '@src/shared/services/get-all-locales';
import { memo } from 'react';

interface CustomFieldCountryCellProps {
  displayValue: string | undefined;
  onValueChange: (value: string | string[]) => void;
}

function CustomFieldCountryCellInner({
  displayValue,
  onValueChange,
}: CustomFieldCountryCellProps) {
  const countries = getCachedLocales();
  const isInitialLoad = !countries;

  const countryName = isInitialLoad
    ? displayValue
    : (displayValue ??
      countries?.find((c) => {
        return c.name === displayValue || c.code === displayValue;
      })?.name);

  return (
    <EditableCountryCell>
      <EditableCountryCellViewMode>
        {countryName || '-'}
      </EditableCountryCellViewMode>

      <EditableCountryCellEditMode
        isSelected={(country) =>
          country.name === displayValue || country.code === displayValue
        }
        onSelect={(country) => onValueChange(country.code)}
      />
    </EditableCountryCell>
  );
}

export const CustomFieldCountryCell = memo(CustomFieldCountryCellInner);
